import React from "react";
import ReactDOM from "react-dom";
import "./confirm-dialog.css";

export default function ConfirmDialog({ title, description, onCancel, onSuccess }) {
    return ReactDOM.createPortal(
        <div className="dialog-overlay" onClick={onCancel}>
            <div id="dialog-container" onClick={(e) => e.stopPropagation()}>
                <div id="dialog-title">{title}</div>
                <div id="dialog-description">{description}</div>
                <div id="dialog-buttons">
                    <button onClick={onCancel}>Cancel</button>
                    <button onClick={onSuccess}>Confirm</button>
                </div>
            </div>
        </div>,
        document.body
    );
}
